import { render, staticRenderFns } from "./editable-script-optimize.vue?vue&type=template&id=3f6de9f1&scoped=true"
import script from "./editable-script-optimize.vue?vue&type=script&setup=true&lang=js"
export * from "./editable-script-optimize.vue?vue&type=script&setup=true&lang=js"
import style0 from "./editable-script-optimize.vue?vue&type=style&index=0&id=3f6de9f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6de9f1",
  null
  
)

export default component.exports